export * from './auth.service';
export * from './alert.service';
export * from './utilizadores.service';
export * from './config.service';
export * from './horas.service';

